// 通用 HTTP 错误工具：识别后端限流/频繁错误
export const RATE_LIMIT_REGEX = /请求过于频繁|频繁|too\s*many\s*requests|rate\s*limit/i

// 安全拦截识别：后端IP封禁/攻击检测返回的统一message
export const SECURITY_BLOCK_REGEX = /网络环境不安全/i

export function isRateLimitError(error) {
  try {
    const status = error?.response?.status
    if (status === 429) return true
    const data = error?.response?.data || {}
    const msg = String(data?.message || data?.error || '')
    if (RATE_LIMIT_REGEX.test(msg)) return true
  } catch (e) {
    // Swallow parsing errors; treat as non rate-limit
    return false
  }
  return false
}

export function isSecurityBlock(error) {
  try {
    const status = error?.response?.status
    if (status === 403) {
      const data = error?.response?.data || {}
      const msg = String(data?.message || data?.error || '')
      if (SECURITY_BLOCK_REGEX.test(msg)) return true
    }
  } catch (e) {
    return false
  }
  return false
}